import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect, useState } from "react";
import { getAllEstimate, getAllParallelEstimate } from "../../actions/EstimateActions";
import { Link } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment/moment";
import DataTable from "react-data-table-component";
import Mobilemenu from "../../layouts/mobile-menu";
import Select from 'react-select';
import { getAllCustomer } from "../../actions/CustomerActions";
import { styleSelect } from "../../constants/customStyles";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";

function Estimate() {

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);

    const estimates = useSelector(state => state?.estimate?.estimates?.data);
    const estimatesPagination = useSelector(state => state?.estimate?.estimates);
    const parallelEstimates = useSelector(state => state?.estimate?.parallelEstimates?.data);
    const parallelEstimatesPagination = useSelector(state => state?.estimate?.parallelEstimates);
    const loading = useSelector(state => state?.loading?.indexLoading);
    const customers = useSelector(state => state?.customer?.customers?.data);
    const user_permissions = JSON.parse(localStorage.getItem('perm'));
    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);

    useEffect(() => {
        dispatch(getAllEstimate(page, currentRowsPerPage, multifilters ?? ''));
        dispatch(getAllParallelEstimate(page, currentRowsPerPage, multifiltersParellel ?? ''));
        dispatch(getAllCustomer(null, 9999, { status: 1 }));
        dispatch(getAllInsuranceCompany(null, 9999, { status: 1 }));
    }, [dispatch])

    const onChangePage = (page, currentRowsPerPage) => {
        setPage(page);
        setCurrentRowsPerPage(currentRowsPerPage);
        const filterParams = multifilters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        dispatch(getAllEstimate(page, currentRowsPerPage, filterParams ?? ''));
    }

    const onChangeParallelPage = (page) => {
        dispatch(getAllParallelEstimate(page, currentRowsPerPage, multifiltersParellel ?? ''));
    }

    useEffect(() => {
        // Update the paginationTotalRows prop to reflect the actual number of rows that are available
        setPaginationTotalRows(estimatesPagination.total);
    }, [estimatesPagination]);

    // useEffect(() => {
    //     getData(page, currentRowsPerPage);
    // }, [page])


    // const getData = (pageNo, currentRowsPerPage = 10) => {
    //     dispatch(getAllEstimate(page, currentRowsPerPage, ''));
    //     dispatch(getAllParallelEstimate(page, currentRowsPerPage));
    // }
    // 'estimates', estimates)

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '40px',
                paddingLeft: '10px',
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {
                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };


    const columns = [
        {
            cell: row => (
                user_permissions.some(item => item.permission_id == '7 ' || item.permission_id == '9' || item.permission_id == '6') ? (
                    <div className="dropdown">
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-40">
                            <div className="dropdown-content">
                                {
                                    user_permissions.some(item => item.permission_id == '7') && (
                                        <Link className="d-flex align-items-center py-1 fs-base me-5" to={`/estimate/add/${row.investigation_id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
                                    )
                                }
                                {
                                    user_permissions.some(item => item.permission_id == '9') && (
                                        <Link to={`/jobCard/add/${row.estimate_id}`} className="d-flex align-items-center py-1 fs-base w-24 me-3 text-theme-10"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Job Card </Link>
                                    )
                                }
                                <Link to={`/estimate/invoice/${row.estimate_id}`} target="_blank" className="d-flex align-items-center fs-base py-1 text-theme-12"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Print </Link>
                            </div>
                        </div>
                    </div>
                ) : null
            ),
        },
        {
            name: 'EST. ID',
            selector: (row, index) => row.estimate_id,
            width: '100px',
            sortable: true,
        },
        {
            name: 'JOB CARD ID',
            selector: (row, index) => row?.job_card?.job_card_id,
            width: '100px',
            sortable: true,
        },
        {
            name: 'CUSTOMER',
            selector: row => row?.customer?.name + ' (' + row?.customer?.mobile + ')',
            sortable: true,
            // width: '25%'
        },
        {
            name: 'CONTRACTOR',
            selector: row => row?.insurance_company?.name,
            sortable: true,
            // width: '25%'
        },
        {
            name: 'PLATE NUMBER',
            selector: row => row?.vehicle?.plate_number,
            // width: '13%'
        },
        {
            name: 'CHASIS NUMBER',
            selector: row => row?.vehicle?.chasis_no,
            // width: '13%'
        },
        {
            name: 'REPAIR TIME',
            selector: row => row.repair_time,
            // width: '13%'
        },
        {
            name: 'PARTS / SERVICES',
            selector: row => row.detail_count,
            // width: '13%'
        },
        {
            name: 'TOTAL AMOUNT (AED)',
            selector: row => row.total_amount,
            // width: '15%'
        },
        {
            name: 'ESTIMATE TOTAL AMOUNT (AED)',
            selector: row => row.estimate_total_amount ?? '-',
            // width: '15%'
        },
        {
            name: 'CREATED ON',
            selector: row => moment(row.created_at).format('YYYY-MM-DD'),
            sortable: true,
            // width: '13%'
        },
        // {
        //     name: 'AMOUNT IN',
        //     selector: row => '-',
        // },

    ];
    const parallelColumns = [
        {
            name: 'EST. ID',
            selector: (row, index) => row.estimate_id,
            width: '100px',
            sortable: true,
        },
        {
            name: 'CUSTOMER',
            selector: row => row?.customer?.name,
            sortable: true,
        },
        {
            name: 'MOBILE NO.',
            selector: row => row?.customer?.mobile,
        },
        {
            name: 'CREATED ON',
            selector: row => moment(row.created_at).format('YYYY-MM-DD'),
            sortable: true,
        },
        // {
        //     name: 'AMOUNT IN',
        //     selector: row => '-',
        // },
        // {
        //     cell: row => {
        //         return (<>
        //             <div className="dropdown">
        //                 <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
        //                     <span className="d-flex align-items-center fs-base justify-content-center">
        //                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
        //                         Actions
        //                     </span>
        //                 </button>
        //                 <div className="dropdown-menu w-40">
        //                     <div className="dropdown-content">
        //                         <Link className="d-flex align-items-center py-1 fs-base me-5" to={`/estimate/add/${row.investigation_id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
        //                         <Link to={`/jobCard/add/${row.estimate_id}`} className="d-flex align-items-center py-1 fs-base w-24 me-3 text-theme-10"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Job Card </Link>
        //                     </div>
        //                 </div>
        //             </div>
        //         </>)
        //     },
        //     width: '300px'
        // },
    ];

    // const [filter, setFilter] = useState('');
    // const [filterOption, setFilterOption] = useState('');

    const [multifilters, setMultiFilters] = useState([]);
    const [multifilterOption, setMultiFilterOption] = useState([]);

    const [multifiltersParellel, setMultiFiltersParellel] = useState([]);
    const [multifilterOptionParellel, setMultiFilterOptionParellel] = useState([]);

    const filterOptions = [
        { value: 'estimate_id', label: 'Estimate #' },
        { value: 'plate_no', label: 'Plate #' },
        { value: 'chasis_no', label: 'Chasis #' },
        { value: 'customer_id', label: 'Customer' },
        { value: 'insurance_company_id', label: 'Contractor' },
    ]

    const handleMultiFilter = (event) => {
        const { name, value } = event.target;
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === name);
            if (index > -1) {
                updatedFilters[index].value = value;
            } else {
                updatedFilters.push({ key: name, value });
            }
            return updatedFilters;
        });
    };

    const handleMultiFilterDropdownCustomer = (selectedOption) => {
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'customer_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };
    const handleMultiFilterDropdownContractor = (selectedOption) => {
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'insurance_company_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'insurance_company_id', value: selectedOption.insurance_company_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'insurance_company_id', value: selectedOption.insurance_company_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };

    // const handleFilter = (event) => {
    //     setFilter({
    //         ...filter,
    //         [event.target.name]: event.target.value,
    //     })
    // }
    // const handleFilters = (event) => {
    //     setFilterOption({
    //         value: event.value,
    //         label: event.label,
    //     })
    // }
    // const handleFilterDropdown = (event) => {
    //     setFilter({
    //         ...filter,
    //         'customer_id': event.customer_id,
    //         'customer_name': event.name,
    //     })
    // }
    // const handleFilterContractorDropdown = (event) => {
    //     setFilter({
    //         ...filter,
    //         'contractor_id': event.insurance_company_id,
    //         'contractor_name': event.name,
    //     })
    // }

    const handleClearFilter = () => {
        // setFilter(null)
        // setFilterOption(null)
        setMultiFilters([]);
        setMultiFilterOption([]);
        dispatch(getAllEstimate(page, currentRowsPerPage, ''))
    }

    // const handleKeyPress = (event) => {
    //     if (event.key === 'Enter') {
    //         event.preventDefault();
    //         filterSearch();
    //     }
    // }

    useEffect(() => {
        const updatedFilters = multifilterOption.map(option => {
            const existingFilter = multifilters.find(filter => filter.key === option.value);
            return existingFilter || { key: option.value, value: '', label: option.label };
        });

        const preservedDateFilters = multifilters.filter(filter =>
            ['date_from', 'date_to'].includes(filter.key) &&
            !multifilterOption.some(option => option.value === filter.key)
        );

        setMultiFilters([...updatedFilters, ...preservedDateFilters]);
    }, [multifilterOption]);

    const filterSearch = () => {
        const filterParams = multifilters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        dispatch(getAllEstimate(1, currentRowsPerPage, filterParams ?? ''))
        // dispatch(getAllEstimate(page, currentRowsPerPage, filter ?? ''))
    }


    const handleMultiFilterParellel = (event) => {
        const { name, value } = event.target;
        setMultiFiltersParellel(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === name);
            if (index > -1) {
                updatedFilters[index].value = value;
            } else {
                updatedFilters.push({ key: name, value });
            }
            return updatedFilters;
        });
    };

    const handleMultiFilterDropdownParellelCustomer = (selectedOption) => {
        setMultiFiltersParellel(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'customer_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };
    const handleMultiFilterDropdownParellelContractor = (selectedOption) => {
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'insurance_company_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'insurance_company_id', value: selectedOption.insurance_company_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'insurance_company_id', value: selectedOption.insurance_company_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };

    // const [parallelFilter, setParallelFilter] = useState('');

    // const handleParallelFilter = (event) => {
    //     setParallelFilter({
    //         ...parallelFilter,
    //         [event.target.name]: event.target.value,
    //     })
    // }
    const handleClearParallelFilter = () => {
        // setParallelFilter('')
        setMultiFiltersParellel([]);
        setMultiFilterOptionParellel([]);
        dispatch(getAllParallelEstimate(page, currentRowsPerPage, ''))
    }

    // const handleKeyPressParallel = (event) => {
    //     if (event.key === 'Enter') {
    //         event.preventDefault();
    //         parallelFilterSearch();
    //     }
    // }

    const parallelFilterSearch = () => {
        const filterParams = multifilters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        dispatch(getAllParallelEstimate(page, currentRowsPerPage, filterParams ?? ''))
        // dispatch(getAllParallelEstimate(page, currentRowsPerPage, parallelFilter ?? ''))
    }

    useEffect(() => {
        const updatedFilters = multifilterOptionParellel.map(option => {
            const existingFilter = multifiltersParellel.find(filter => filter.key === option.value);
            return existingFilter || { key: option.value, value: '', label: option.label };
        });

        const preservedDateFilters = multifiltersParellel.filter(filter =>
            ['date_from', 'date_to'].includes(filter.key) &&
            !multifilterOptionParellel.some(option => option.value === filter.key)
        );

        setMultiFiltersParellel([...updatedFilters, ...preservedDateFilters]);
    }, [multifilterOptionParellel]);


    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {/* {
                    loading ?
                        <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2d3748"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                            wrapperClassName=""
                            visible={loading}
                        /> : */}
                    <span>
                        {/* <!-- BEGIN: Data List --> */}
                        <div className="py-5">
                            <ul className="pos__tabs nav nav-pills rounded-2" role="tablist">
                                <li id="investigations-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                    <button className="nav-link w-full pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#investigations" type="button" role="tab" aria-controls="investigations-tab" aria-selected="true">Estimates</button>
                                </li>
                                <li id="parallelInvestigations-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                    <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#parallelInvestigations" type="button" role="tab" aria-controls="parallelInvestigations-tab" aria-selected="false">Parallel Estimates</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="investigations" role="tabpanel" aria-labelledby="investigations-tab">
                                    <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                                        {
                                            user_permissions.some(item => item.permission_id == '6' && '3') &&
                                            <Link to="/investigation/add">
                                                <button className="btn btn-primary shadow-md me-2">Add New</button>
                                            </Link>
                                        }
                                        {/* <div className="w-full w-sm-auto mt-3 mt-sm-0 ms-sm-auto ms-md-0">
                                                <div className="w-56 position-relative text-gray-700 dark-text-gray-300">
                                                    <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                </div>
                                            </div> */}
                                        <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                            aria-controls="faq-accordion-collapse-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                            Filters </button>
                                    </div>
                                    <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                                        data-bs-parent="#faq-accordion-1">
                                        <div class="grid columns-12 gap-6 mt-5">
                                            <div class="intro-y g-col-12 g-col-lg-12">
                                                <div class="intro-y box p-5">
                                                    <div class="row">
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date From</label>
                                                            <input
                                                                type="date"
                                                                name="date_from"
                                                                value={multifilters.find(filter => filter.key === 'date_from')?.value || ''}
                                                                onChange={handleMultiFilter}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date To</label>
                                                            <input
                                                                type="date"
                                                                name="date_to"
                                                                value={multifilters.find(filter => filter.key === 'date_to')?.value || ''}
                                                                onChange={handleMultiFilter}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label">Filter</label>
                                                            <Select
                                                                isMulti
                                                                styles={styleSelect}
                                                                value={multifilterOption || []}
                                                                onChange={setMultiFilterOption}
                                                                options={filterOptions}
                                                            />
                                                        </div>
                                                        {multifilters
                                                            .filter(filter => !['date_from', 'date_to'].includes(filter.key))
                                                            .map((filter, index) => (
                                                                filter.key === 'customer_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Customer Name</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdownCustomer}
                                                                            value={customers && customers.find(cust => cust.customer_id === filter.value) || null}
                                                                            getOptionLabel={option => `${option.name} - ${option.mobile || 'N/A'}`}
                                                                            getOptionValue={option => option.customer_id}
                                                                            options={customers || []}
                                                                            styles={styleSelect}
                                                                        />
                                                                    </div>
                                                                ) : filter.key === 'insurance_company_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Insurance Company</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdownContractor}
                                                                            value={{ insurance_company_id: filter.value, name: filter.label }}
                                                                            getOptionLabel={option => option.name}
                                                                            getOptionValue={option => option.insurance_company_id}
                                                                            options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                                            styles={styleSelect}
                                                                            placeholder="Select Insurance Companies"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">{filterOptions.find(opt => opt.value === filter.key)?.label}</label>
                                                                        <input
                                                                            type="text"
                                                                            value={filter.value}
                                                                            onChange={(event) => handleMultiFilter({ target: { name: filter.key, value: event.target.value } })}
                                                                            className="form-control w-full"
                                                                        />
                                                                    </div>
                                                                )
                                                            ))}
                                                    </div>
                                                    <div class="text-end mt-5">
                                                        <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                            Search</button>
                                                        <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12 overflow-y-visible h-screen">
                                        <div className='mt-2 overflow-x-auto overflow-y-visible h-screen'>
                                            <DataTable
                                                className="overflow-lg-visible"
                                               columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                                data={estimates && estimates.length > 0 ? estimates : []}
                                                progressPending={loading}
                                                progressComponent={<ThreeDots
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color="#2d3748"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                                    wrapperClassName=""
                                                    visible={loading}
                                                />}
                                                pagination
                                                paginationServer
                                                customStyles={customStyles}
                                                paginationTotalRows={paginationTotalRows}
                                                onChangeRowsPerPage={(currentRowsPerPage) => onChangePage(page, currentRowsPerPage)}
                                                onChangePage={(page) => onChangePage(page, currentRowsPerPage)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade show" id="parallelInvestigations" role="tabpanel" aria-labelledby="parallelInvestigations-tab">
                                    <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                                        {/* <div className="w-full w-sm-auto mt-3 mt-sm-0 ms-sm-auto ms-md-0">
                                                <div className="w-56 position-relative text-gray-700 dark-text-gray-300">
                                                    <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                </div>
                                            </div> */}
                                        <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                            aria-controls="faq-accordion-collapse-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                            Filters </button>
                                    </div>
                                    <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                                        data-bs-parent="#faq-accordion-1">
                                        <div class="grid columns-12 gap-6 mt-5">
                                            <div class="intro-y g-col-12 g-col-lg-12">
                                                <div class="intro-y box p-5">
                                                    <div class="row">
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date From</label>
                                                            <input
                                                                type="date"
                                                                name="date_from"
                                                                value={multifiltersParellel.find(filter => filter.key === 'date_from')?.value || ''}
                                                                onChange={handleMultiFilterParellel}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date To</label>
                                                            <input
                                                                type="date"
                                                                name="date_to"
                                                                value={multifiltersParellel.find(filter => filter.key === 'date_to')?.value || ''}
                                                                onChange={handleMultiFilterParellel}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label">Filter</label>
                                                            <Select
                                                                isMulti
                                                                styles={styleSelect}
                                                                value={multifilterOptionParellel || []}
                                                                onChange={setMultiFilterOptionParellel}
                                                                options={filterOptions}
                                                            />
                                                        </div>
                                                        {multifiltersParellel
                                                            .filter(filter => !['date_from', 'date_to'].includes(filter.key))
                                                            .map((filter, index) => (
                                                                filter.key === 'customer_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Customer Name</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdownParellelCustomer}
                                                                            value={{ customer_id: filter.value, name: filter.label }}
                                                                            getOptionLabel={option => option.name}
                                                                            getOptionValue={option => option.customer_id}
                                                                            options={customers || []}
                                                                            styles={styleSelect}
                                                                        />
                                                                    </div>
                                                                ) : filter.key === 'insurance_company_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Insurance Company</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdownParellelContractor}
                                                                            value={{ insurance_company_id: filter.value, name: filter.label }}
                                                                            getOptionLabel={option => option.name}
                                                                            getOptionValue={option => option.insurance_company_id}
                                                                            options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                                            styles={styleSelect}
                                                                            placeholder="Select Insurance Companies"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">{filterOptions.find(opt => opt.value === filter.key)?.label}</label>
                                                                        <input
                                                                            type="text"
                                                                            value={filter.value}
                                                                            onChange={(event) => handleMultiFilterParellel({ target: { name: filter.key, value: event.target.value } })}
                                                                            className="form-control w-full"
                                                                        />
                                                                    </div>
                                                                )
                                                            ))}
                                                    </div>
                                                    <div class="text-end mt-5">
                                                        <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => parallelFilterSearch()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                            Search</button>
                                                        <button onClick={handleClearParallelFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12 overflow-y-visible h-screen">
                                        <div className='mt-2 overflow-x-auto overflow-y-visible h-screen'>
                                            <DataTable
                                                className="overflow-lg-visible"
                                                columns={parallelColumns}
                                                data={parallelEstimates && parallelEstimates.length > 0 ? parallelEstimates : []}
                                                progressPending={loading}
                                                progressComponent={<ThreeDots
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color="#2d3748"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                                    wrapperClassName=""
                                                    visible={loading}
                                                />}
                                                pagination
                                                paginationServer
                                                customStyles={customStyles}
                                                paginationTotalRows={paginationTotalRows}
                                                onChangeRowsPerPage={(currentRowsPerPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                                onChangePage={onChangeParallelPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- END: Data List --> */}
                        </div>
                    </span>
                    {/* } */}
                </div>
            </div>
        </span>
    )
}
export default Estimate;